import lineDistance from '@turf/length';
import { lineString } from '@turf/helpers';

function extrudeFeatures(features, delta) {
    features.forEach(feature => {
        if (feature.type === 'Polygon' || feature.type === 'MultiPolygon') {
            // const height = +Math.max((feature.properties.height || 0.0) + delta, 0.0).toFixed(1);
            const height = Math.max((feature.properties.height || 0.0) + delta, 0.0);
            if (height) {
                feature.properties.height = height;
            } else {
                delete feature.properties.height;
            }
            feature.changed();
        }
    });
}

const CommonSelect = {
    isAltDown: function (e) {
        if (!e.originalEvent) return false;
        return e.originalEvent.altKey === true;
    },

    startOnActiveFeature: function (state, e) {
        state.extrudingTargetId =
            state.canDragMove &&
            (CommonSelect.isAltDown(e) ||
                this._ctx.api.getMode() === this._ctx.api.modes.EXTRUDE_MODE) &&
            (e.featureTarget.geometry.type === 'Polygon' ||
                e.featureTarget.geometry.type === 'MultiPolygon')
                ? e.featureTarget.properties.id
                : null;
        if (state.extrudingTargetId) {
            state.dragExtrudePosition = e.point;
        }
        // this.map.fire("draw.editing", {
        //     features: [e.featureTarget]
        // });
    },

    dragMove: function (state, e) {
        // Dragging when drag move is enabled
        state.dragMoving = true;
        e.originalEvent.stopPropagation();

        const pitch = this.map.getPitch();
        let delta;
        if (pitch < 20) {
            delta = (state.dragExtrudePosition.y - e.point.y) * 0.1;
        } else {
            const verticalPoint = { x: state.dragExtrudePosition.x, y: e.point.y };
            const verticalLngLat = this.map.unproject(verticalPoint);
            const line = lineString([
                [verticalLngLat.lng, verticalLngLat.lat],
                [state.dragMoveLocation.lng, state.dragMoveLocation.lat]
            ]);
            let verticalDistance =
                lineDistance(line, { units: 'kilometers' }) * 1000;
            if (e.point.y > state.dragExtrudePosition.y) {
                verticalDistance = -verticalDistance;
            }
            delta = verticalDistance / Math.tan((pitch * Math.PI) / 180);
        }
        // console.log("delta: ", delta);

        extrudeFeatures(this.getSelected(), delta);
        state.dragMoveLocation = e.lngLat;
        state.dragExtrudePosition = e.point;
    },

    toDisplayFeatures: function (state, geojson, display) {
        if (state.extrudingTargetId === geojson.properties.id) {
            this.map.fire('draw.editing', {
                features: [geojson]
            });
        }
    }
};

export default CommonSelect;
